import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';
import E2ERun from '../../models/E2ERun';

export class GetE2ERunPayload {
  constructor(public runKey: string) {}
}
async function getE2ERun(payload: GetE2ERunPayload): Promise<E2ERun> {
  try {
    const response = await HttpClient.get(
      `/backoffice/e2e-results/${encodeURIComponent(payload.runKey)}`
    );
    return E2ERun.fromApi(response.data);
  } catch (error) {
    throw new GetE2ERunFailure(error instanceof Error ? error.message : 'Chargement impossible');
  }
}
class GetE2ERunFailure extends Failure {
  constructor(message: string) {
    super(message, 'e2e-detail-failed');
  }
}
export default getE2ERun;
